import React from "react";

import { 
  Button,
  Row,
  Col
} from "react-bootstrap-v5";

import Utils from "../../../utils/utils";

const ViewTopSection = (props) =>  {
  // let currentValue = Utils.getCookie();
  let currentValue = Utils.getProjectVersion();
  let isV4 = (currentValue == null || currentValue == 'v4');

  return (
    <Row className="view-top-section-layout align-items-center">
      <Col xs={12} sm={true} className={'mb-2 mb-md-0'}>
        <h1 className={'title mx-0'}>DASHBOARD</h1>
      </Col>
      <Col xs={true} sm={'auto'} className={'text-end mb-2 mb-md-0'}>      
      <a className="btn btn-primary w-100" 
          href={(!isV4) ? '/v5/job-form-beta' : '/jobs-form'}
        >CREATE JOB</a>  
      </Col>
    </Row>
  )
}

export default ViewTopSection;
